import React from "react";
import Icon from './Icon';

export default class Loading extends React.PureComponent {
    render() {
        return (
            <Icon className={'loading'} img={require('../../../assets/images/icons/loader.svg')}/>
        );
    }
}
